<!-- Add Permission Modal  -->
<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Add Permission</h4>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">

            <!-- role name 
            <div class="row">

              <div class="col">
                <label><b>Role</b></label>
              </div>

              <div class="col">
                <p>Put role name</p>
              </div>
            </div> -->

            <!-- select permission -->
            <div class="row">

              <div class="col">
                <label><b>Permission</b></label>
              </div>

              <div class="col">
                <select class="form-control" required [(ngModel)]="selectedPermissionId" name="selectedPermissionId"
                  id="selectedPermissionId" style="padding: 0px; margin-bottom: 10px; height: auto;">
                  <option value="">-- Select permission --</option>
                  <option [value]="permission.id" *ngFor="let permission of SystemPermissions">
                    {{permission.permissionDisplayName}} </option>
                </select>
              </div>
            </div>

            <!-- Write  -->
            <div class="row">

              <div class="col">
                <label><b>Can Add</b></label>
              </div>

              <div class="col">
                <input type="checkbox" value="CanAdd" [(ngModel)]="CanAdd" name="CanAdd" id="CanAdd" />
              </div>
            </div>

            <!-- Read  -->
            <div class="row">

              <div class="col">
                <label><b>Can Read</b></label>
              </div>

              <div class="col">
                <input type="checkbox" value="CanRead" [(ngModel)]="CanRead" name="CanRead" id="CanRead" />
              </div>
            </div>

            <!-- Edit  -->
            <div class="row">

              <div class="col">
                <label><b>Can Edit</b></label>
              </div>

              <div class="col">
                <input type="checkbox" value="CanEdit" [(ngModel)]="CanEdit" name="CanEdit" id="CanEdit" />
              </div>
            </div>

            <!-- Delete  -->
            <div class="row">

              <div class="col">
                <label><b>Can Delete</b></label>
              </div>

              <div class="col">
                <input type="checkbox" value="CanDelete" [(ngModel)]="CanDelete" name="CanDelete" id="CanDelete" />
              </div>
            </div>

            <!-- Approve  -->
            <div class="row">

              <div class="col">
                <label><b>Can Approve</b></label>
              </div>

              <div class="col">
                <input type="checkbox" value="CanApprove" [(ngModel)]="CanApprove" name="CanApprove" id="CanApprove" />
              </div>
            </div>

 <!-- Terminate  -->
 <div class="row">

  <div class="col">
    <label><b>Can Terminate</b></label>
  </div>

  <div class="col">
    <input type="checkbox" value="CanTerminate" [(ngModel)]="CanTerminate" name="CanTerminate" id="CanTerminate" />
  </div>
</div>

          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="addPermission()">Add</button>
    <button type="button" class="btn btn-light" (click)="modal.close('Close click')">Close</button>
  </div>
</ng-template>
<!-- Add Permission Modal End -->

<!-- Update Permission Modal  -->
<ng-template #update let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Update Permission</h4>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">

            <!-- role name  -->
            <div class="row">

              <div class="col">
                <label><b>Role</b></label>
              </div>

              <div class="col">
                <p>{{UpdatePermission.roleName}}</p>
              </div>
            </div>

            <!-- select permission -->
            <div class="row">

              <div class="col">
                <label><b>Permission</b></label>
              </div>

              <div class="col">
                <p>{{UpdatePermission.permissionName}}</p>
              </div>
            </div>

            <!-- Write  -->
            <div class="row">

              <div class="col">
                <label><b>Can Add</b></label>
              </div>

              <div class="col">
                <input type="checkbox" value="UpdateCanAdd" [(ngModel)]="UpdatePermission.canAdd"
                  [checked]="UpdatePermission.canAdd" name="UpdateCanAdd" id="UpdateCanAdd" />
              </div>
            </div>

            <!-- Read  -->
            <div class="row">

              <div class="col">
                <label><b>Can Read</b></label>
              </div>

              <div class="col">
                <input type="checkbox" value="UpdateCanRead" [(ngModel)]="UpdatePermission.canRead"
                  [checked]="UpdatePermission.canRead" name="UpdateCanRead" id="UpdateCanRead" />
              </div>
            </div>

            <!-- Edit  -->
            <div class="row">

              <div class="col">
                <label><b>Can Edit</b></label>
              </div>

              <div class="col">
                <input type="checkbox" value="UpdatePermission.canEdit" [(ngModel)]="UpdatePermission.canEdit"
                  [checked]="UpdatePermission.canEdit" name="UpdateCanEdit" id="UpdateCanEdit" />
              </div>
            </div>

            <!-- Delete  -->
            <div class="row">

              <div class="col">
                <label><b>Can Delete</b></label>
              </div>

              <div class="col">
                <input type="checkbox" value="UpdateCanDelete" [(ngModel)]="UpdatePermission.canDelete"
                  [checked]="UpdatePermission.canDelete" />
              </div>
            </div>

            <!-- Approve  -->
            <div class="row">

              <div class="col">
                <label><b>Can Approve</b></label>
              </div>

              <div class="col">
                <input type="checkbox" value="UpdateCanApprove" [(ngModel)]="UpdatePermission.canApprove"
                  [checked]="UpdatePermission.canApprove" />
              </div>
            </div>

 <!-- Terminate  -->
 <div class="row">

  <div class="col">
    <label><b>Can Terminate</b></label>
  </div>

  <div class="col">
    <input type="checkbox" value="UpdateCanTerminate" [(ngModel)]="UpdatePermission.canTerminate"
      [checked]="UpdatePermission.canTerminate" />
  </div>
</div>

          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-warning" (click)="updatePermission()">Update</button>
    <button type="button" class="btn btn-light" (click)="modal.close('Close click')">Close</button>
  </div>
</ng-template>
<!-- Update Permission Modal End -->

<div class="content-wrapper">
  <div class="row">


    <div class="col-lg-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">Roles</h4>
          <div class="table-responsive pt-3">

            <!-- Role  -->
            <div class="col">
              <div class="form-group">
                <label for="exampleSelectRole">Role</label>
                <select class="form-control" required [(ngModel)]="selectedRoleId" name="selectedRoleId"
                  id="selectedRoleId" #mySelect (change)='onOptionsSelected(mySelect.value)'>
                  <option value="">-- Select role --</option>
                  <option [value]="role.id" *ngFor="let role of Roles">{{role.roleName}} </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="col-lg-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <div class="card-title">
            <h4 class="d-inline-block">Role Permissions</h4>
            <button style="float: right;" *ngIf="selectedRoleId" class="btn btn-primary mr-2"
              (click)="openModal(content)">Add Permission</button>
          </div>
          <div class="table-responsive pt-3">
            <table class="table table-striped table-hover">
              <thead>
                <tr>
                  <th>
                    S/N
                  </th>

                  <th>
                    Permission Name
                  </th>
                  <th>
                    Can View
                  </th>
                  <th>
                    Can Create
                  </th>
                  <th>
                    Can Update
                  </th>
                  <th>
                    Can Delete
                  </th>
                  <th>
                    Can Approve
                  </th>
                  <th>
                    Can Terminate
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let permission of RolePermissions; let i = index"
                  (click)="openUpdateModal(update, permission)" class="clickable">

                  <td style="width:0px;">
                    {{i + 1}}
                  </td>

                  <td>
                    {{permission.permissionName}}
                  </td>

                  <td>
                    <label class="custom-control custom-checkbox">
                      <input type="checkbox" value="canRead" [checked]="permission.canRead" disabled />
                    </label>
                  </td>

                  <td>
                    <label class="custom-control custom-checkbox">
                      <input type="checkbox" value="canAdd" [checked]="permission.canAdd" disabled />
                    </label>
                  </td>
                  <td>
                    <label class="custom-control custom-checkbox"><input type="checkbox" value="canEdit"
                        [checked]="permission.canEdit" disabled /></label>
                  </td>
                  <td>
                    <label class="custom-control custom-checkbox"><input type="checkbox" value="canDelete"
                        [checked]="permission.canDelete" disabled /></label>
                  </td>
                  <td>
                    <label class="custom-control custom-checkbox"><input type="checkbox" value="canApprove"
                        [checked]="permission.canApprove" disabled /></label>
                  </td>
                  <td>
                    <label class="custom-control custom-checkbox"><input type="checkbox" value="canTerminate"
                        [checked]="permission.canTerminate" disabled /></label>
                  </td>
                  <!-- <td>
                    <button type="button" class="btn btn-sm btn-link">
                      <i class="icon-software-pencil text-blue"></i>
                    </button>
                    <button type="button" class="btn btn-sm btn-link btn-clear px-2">
                      <i class="icon-basic-trashcan text-red"></i>
                    </button>
                  </td> -->

                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>